<template>
  <el-card shadow="never" style="margin-top: 20px">
    <iframe :src="content" :style="`width: ${width}; height: ${height}; border: none`"></iframe>
  </el-card>
</template>

<script>
export default {
  props: ["content", "width", "height"],
};
</script>
